module.exports = __webpack_public_path__ + "img/DSC_0025.621008da.jpg";